import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { KcButtonComponent, KcDialogComponent } from '@kaspacom/ui-kit';
import { Kcc20ConsolidationStatus } from '../../services/token-actions/kcc20-token-action-api.service';
import { formatKcc20BaseUnitsValueGrouped } from '../../shared/kcc20-token-amount';

export interface TokenConsolidationDialogData {
  tokenLabel: string;
  requestedTokenAmount: string;
  status: Kcc20ConsolidationStatus;
  consolidateOnly?: boolean;
  consolidateAll?: boolean;
}

@Component({
  selector: 'app-token-consolidation-dialog',
  standalone: true,
  imports: [KcButtonComponent, KcDialogComponent],
  templateUrl: './token-consolidation-dialog.component.html',
  styleUrl: './token-consolidation-dialog.component.scss',
})
export class TokenConsolidationDialogComponent {
  protected readonly data = inject<TokenConsolidationDialogData>(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef<boolean>);

  protected readonly assetLabel =
    this.data.status.asset === 'native' ? 'asset balance' : 'trading balance';
  protected readonly totalBalance = this.format(
    this.data.status.aggregateAmount,
  );
  protected readonly reserveChunking =
    this.data.status.reason === 'action_chunking_required';
  protected readonly largestUtxo = this.format(
    this.reserveChunking
      ? (this.data.status.maxSingleReserveAmount ?? '0')
      : this.data.status.maxSingleUtxoAmount,
  );
  protected readonly outputCount = this.reserveChunking
    ? (this.data.status.reserveUtxoCount ?? 0)
    : this.data.status.compatibleUtxoCount;
  protected readonly approvals =
    this.data.status.estimatedMergeTransactions +
    (this.data.consolidateOnly
      ? 0
      : (this.data.status.estimatedActionTransactions ?? 1));

  protected confirm(): void {
    this.dialogRef.close(true);
  }

  protected close(): void {
    this.dialogRef.close(false);
  }

  private format(value: string): string {
    return formatKcc20BaseUnitsValueGrouped(
      value,
      this.data.status.decimals,
      '0',
      8,
    );
  }
}
